import React from 'react';

import Answer from './Answer/Answer';

import './Answers.scss';    

const Answers = props => {

    let valDir = (len, idx) => {
        return (props.dirDown ? (100 - ((100/len)* (0+idx)) ) : (100/len * (idx+1)));
    } 

    return (
        <div className="Answers">
            <form>
                {(props.answers.map((answer, i) =>{
                    const ordered1 = valDir(props.answers.length, i);

                    return (
                        <Answer
                            answer={answer}
                            key={`Answer--${i}`}
                            pnlIdx={props.pnlIdx}
                            ansIdx={i}
                            value={(props.cv !== undefined ? props.cv[i] : ordered1)}
                        />
                    );
                }                    
                ))}
            </form>
        </div>
    );
}

export default Answers;